/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './checkbox-field.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../../../app/modules/fields/components/checkbox-field/checkbox-field.component';
import * as i4 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i5 from '@angular/material';
const styles_CheckboxFieldComponent:any[] = [i0.styles];
export const RenderType_CheckboxFieldComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_CheckboxFieldComponent,data:{}});
export function View_CheckboxFieldComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),17,'div',([] as any[]),
      [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
          (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
          [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
          'submit'],[(null as any),'reset']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('submit' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onSubmit($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('reset' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,1).onReset()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(1,540672,(null as any),0,i2.FormGroupDirective,
      [[8,(null as any)],[8,(null as any)]],{form:[0,'form']},(null as any)),i1.ɵprd(2048,
      (null as any),i2.ControlContainer,(null as any),[i2.FormGroupDirective]),i1.ɵdid(3,
      16384,(null as any),0,i2.NgControlStatusGroup,[i2.ControlContainer],(null as any),
      (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(5,0,
      (null as any),(null as any),6,'md-checkbox',[['class','example-margin mat-checkbox']],
      [[8,'id',0],[2,'mat-checkbox-indeterminate',(null as any)],[2,'mat-checkbox-checked',
          (null as any)],[2,'mat-checkbox-disabled',(null as any)],[2,'mat-checkbox-label-before',
          (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
      [[(null as any),'change']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i3.CheckboxFieldComponent = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>_co.handleChange($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i4.View_MdCheckbox_0,i4.RenderType_MdCheckbox)),i1.ɵdid(6,16384,(null as any),
      0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(7,4374528,[['bool',4]],0,i5.MdCheckbox,[i1.Renderer2,
      i1.ElementRef,i1.ChangeDetectorRef,i5.FocusOriginMonitor],{disabled:[0,'disabled']},
      {change:'change'}),i1.ɵprd(1024,(null as any),i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
    return [p0_0];
  },[i5.MdCheckbox]),i1.ɵdid(9,671744,(null as any),0,i2.FormControlName,[[3,i2.ControlContainer],
      [8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],{name:[0,'name'],
      isDisabled:[1,'isDisabled']},(null as any)),i1.ɵprd(2048,(null as any),i2.NgControl,
      (null as any),[i2.FormControlName]),i1.ɵdid(11,16384,(null as any),0,i2.NgControlStatus,
      [i2.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n  '])),(_l()(),i1.ɵeld(13,0,(null as any),(null as any),3,'md-hint',[['align',
      'start'],['class','mat-hint']],[[2,'mat-right',(null as any)],[1,'id',0],[1,
      'align',0]],(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(14,
      16384,(null as any),0,i5.MdPrefixRejector,[[2,i5.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(15,16384,(null as any),
      0,i5.MdHint,([] as any[]),{align:[0,'align']},(null as any)),(_l()(),i1.ɵted(16,
      (null as any),['\n    ','\n    ','\n  '])),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.CheckboxFieldComponent = _v.component;
    const currVal_7:any = _co.form;
    _ck(_v,1,0,currVal_7);
    const currVal_20:boolean = !_co.editable;
    _ck(_v,7,0,currVal_20);
    const currVal_21:any = _co.getKey();
    const currVal_22:boolean = !_co.editable;
    _ck(_v,9,0,currVal_21,currVal_22);
    const currVal_26:any = 'start';
    _ck(_v,15,0,currVal_26);
  },(_ck,_v) => {
    var _co:i3.CheckboxFieldComponent = _v.component;
    const currVal_0:any = i1.ɵnov(_v,3).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,3).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,3).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,3).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,3).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,3).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,3).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = i1.ɵnov(_v,7).id;
    const currVal_9:any = i1.ɵnov(_v,7).indeterminate;
    const currVal_10:any = i1.ɵnov(_v,7).checked;
    const currVal_11:any = i1.ɵnov(_v,7).disabled;
    const currVal_12:any = (i1.ɵnov(_v,7).labelPosition == 'before');
    const currVal_13:any = i1.ɵnov(_v,11).ngClassUntouched;
    const currVal_14:any = i1.ɵnov(_v,11).ngClassTouched;
    const currVal_15:any = i1.ɵnov(_v,11).ngClassPristine;
    const currVal_16:any = i1.ɵnov(_v,11).ngClassDirty;
    const currVal_17:any = i1.ɵnov(_v,11).ngClassValid;
    const currVal_18:any = i1.ɵnov(_v,11).ngClassInvalid;
    const currVal_19:any = i1.ɵnov(_v,11).ngClassPending;
    _ck(_v,5,1,[currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,
        currVal_15,currVal_16,currVal_17,currVal_18,currVal_19]);
    const currVal_23:any = (i1.ɵnov(_v,15).align == 'end');
    const currVal_24:any = i1.ɵnov(_v,15).id;
    const currVal_25:any = (null as any);
    _ck(_v,13,0,currVal_23,currVal_24,currVal_25);
    const currVal_27:any = (_co.fieldValue.field.required? '': '(Not Required)');
    const currVal_28:any = (_co.fieldValue.field.hint? _co.fieldValue.field.hint: '');
    _ck(_v,16,0,currVal_27,currVal_28);
  });
}
export function View_CheckboxFieldComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-checkbox',
      ([] as any[]),[[2,'not-required',(null as any)]],(null as any),(null as any),
      View_CheckboxFieldComponent_0,RenderType_CheckboxFieldComponent)),i1.ɵdid(1,
      49152,(null as any),0,i3.CheckboxFieldComponent,([] as any[]),(null as any),
      (null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).isNotRequired;
    _ck(_v,0,0,currVal_0);
  });
}
export const CheckboxFieldComponentNgFactory:i1.ComponentFactory<i3.CheckboxFieldComponent> = i1.ɵccf('app-checkbox',
    i3.CheckboxFieldComponent,View_CheckboxFieldComponent_Host_0,{editable:'editable',
        form:'form',fieldValue:'fieldValue'},{fieldValueChange:'fieldValueChange',
        edited:'edited'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/fields/components/checkbox-field/checkbox-field.component.ngfactory.ts